import { render, staticRenderFns } from "./productitem.vue?vue&type=template&id=14ea2311&scoped=true"
import script from "./productitem.vue?vue&type=script&lang=js"
export * from "./productitem.vue?vue&type=script&lang=js"
import style0 from "./productitem.vue?vue&type=style&index=0&id=14ea2311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea2311",
  null
  
)

export default component.exports